<script>
import getSecret from '@utils/get-secret'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import BaseDatatable from '@components/base-datatable'
import { smartCarMethods } from '@state/helpers'
import cardholderForm from '@views/smart_car/form'
import cardholderDelete from '@components/euro_smart_car/delete'

var colors = {
  hex: '#194d33',
  a: 1,
}

export default {
  page: {
    title: 'Cargar Bin SmartCar',
    meta: [{ name: 'description', content: getSecret('DESCRIPTION') }],
  },
  components: {
    EuroSmartCarUploadData: () => import('@components/euro_smart_car/UploadData'),
    Layout, PageHeader, BaseDatatable, 
    cardholderForm, cardholderDelete },
  data() {
    return {
      title: 'Cargar Bin SmartCar',
      items: [
        {
          text: 'Inicio',
          href: '/',
        },
        {
          text: 'Bin SmartCar',
          active: true,
        },
      ],
      tableHeaders: [
        { key: 'document_type', label: 'Tipo Identificación' },
        { key: 'document', label: 'Numero Identificación' },
        { key: 'bin', label: 'BIN' },
        { key: 'status', align: 'center', label: '¿Habilitado?' },
        { key: 'created_at', label: 'Fecha de Ingreso' },
        { key: 'updated_at', label: 'Fecha de Modificación' },
        { key: 'actions', label: 'Acciones' },
      ],
      action: '',
      detailModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      toUpdate : {},
      toDelete: {},
      showForm: false,
      showFormEdit: false,
      showFormDelete: false,
      typeAction:'create',
      showDelete: false,
      isSubmitting: false,
      actionsLoadings: {},
    }
  },
  methods: {
    ...smartCarMethods,
    myProvider(ctx) {
      const promise = this.fetchCardholders(this.$table_params(ctx))
      return promise
        .then((data) => {
          return data
        })
        .catch((error) => {
          this.$axios_error_noty(error, this)
          console.log(error)
          return []
        })
    },
    openCreateUpdateModal(item, row) {
      let context = this
      if (item) {
        context.toUpdate = item
      } else {
        context.toUpdate = {}
      }
      context.showForm = true
      context.typeAction = 'create'
    },
    openDeleteUpdateModal(item, row) {
      let context = this
      if (item) {
        context.toUpdate = item
      } else {
        context.toUpdate = {}
      }
      context.showForm = true
      context.typeAction = 'delete'
    },
    openUpdateModal(item, row) {
      let context = this
      if (item) {
        context.toUpdate = item
      } else {
        context.toUpdate = {}
      }
      context.showFormEdit = true
      context.typeAction = 'update'
    },
    openDeleteModal(item, row) {
      let context = this
      if (item) {
        context.toDelete = item
      } else {
        context.toDelete = {}
      }
      context.showFormDelete = true
    },
  },
}
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-container fluid class="p-0">
      <b-row>
        <b-col>
          <b-card class="shadow">

            <BaseDatatable
              ref="table"
              :drfprovider="myProvider"
              :tableheaders="tableHeaders"
            > 
              <template v-slot:buttons>
                <b-button
                  variant="outline-primary rounded-lg shadow-sm"
                  size="sm"
                  @click="openCreateUpdateModal(null, null)"
                >
                  <i class=" fas fa-plus"></i>
                </b-button>
                <b-button
                  style="margin-left: 0.5rem;"
                  variant="outline-primary rounded-lg shadow-sm"
                  size="sm"
                  @click="openDeleteUpdateModal(null, null)"
                >
                  <i class=" fas fa-trash-alt"></i>
                </b-button>
              </template>
              <template v-slot:cell(document_type)="row">
                {{ row.item.document_type }}
              </template>
              <template v-slot:cell(document)="row">
                {{ row.item.document }}
              </template>
              <template v-slot:cell(bin)="row">
                {{ row.item.bin }}
              </template>
              <template v-slot:cell(status)="row">
                <span
                  v-if="row.item.status"
                  class="fe-check-circle text-success"
                ></span>
                <span v-else class="fe-x-circle text-danger"></span>
              </template>
              <template v-slot:cell(created_at)="row">
                {{ row.item.created_at.split('T')[0] + ' ' + row.item.created_at.split('T')[1].substring(0, 5) }}
              </template>
              <template v-slot:cell(updated_at)="row">
                {{ row.item.updated_at.split('T')[0] + ' ' + row.item.updated_at.split('T')[1].substring(0, 5) }}
              </template>
              <template v-slot:cell(actions)="row">
                <b-button-group size="xs">
                  <b-button
                    :id="`update-btn-${row.index}`"
                    :disabled="isSubmitting"
                    v-b-tooltip.hover="{
                      variant: 'warning',
                      placement: 'leftbottom',
                      title: 'Editar',
                    }"
                    variant="btn-link text-warning btn-transparent"
                    size="xs"
                    @click="openUpdateModal(row.item, row.index)"
                  >
                    <i class="fe-edit fe-2x"></i>
                  </b-button>

                  <b-button
                    :id="`delete-btn-${row.index}`"
                    :disabled="isSubmitting"
                    v-b-tooltip.hover="{
                      variant: 'danger',
                      placement: 'leftbottom',
                      title: 'Eliminar',
                    }"
                    variant="btn-link text-danger btn-transparent"
                    size="xs"
                    @click="openDeleteModal(row.item, row.index)"
                  >
                    <i class="fe-x fe-2x"></i>
                  </b-button>
                </b-button-group>
              </template>
            </BaseDatatable>
          </b-card>
        </b-col>
      </b-row>
    </b-container>

    <EuroSmartCarUploadData
      v-if="showForm"
      :type_action="typeAction"
      :fullform="true"
      :instanceJson="toUpdate || {}"
      :oncomplete="
        () => {
          showForm = false
          toUpdate = {}
          $refs.table.refresh()
        }
      "
      :oncancel="
        () => {
          showForm = false
          toUpdate = {}
        }
      "
    >
    </EuroSmartCarUploadData>

    <cardholderForm
      v-if="showFormEdit"
      :instanceJson="toUpdate || {}"
      :oncomplete="
        () => {
          showFormEdit = false;
          toUpdate = {};
          $refs.table.refresh()
        }
      "
      :oncancel="
        () => {
          showFormEdit = false;
          toUpdate = {}
        }
      "
    >
    </cardholderForm>

    <cardholderDelete
      v-if="showFormDelete"
      :instanceJson="toDelete"
      :oncomplete="
        () => {
          showFormDelete = false;
          toDelete = {};
          $refs.table.refresh()
        }
      "
      :oncancel="
        () => {
          showFormDelete = false;
          toDelete = {}
        }
      "
    >
    </cardholderDelete>
  </Layout>
</template>
